import React, { useState } from 'react'
import { useNavigate } from 'react-router'
import { useAppSelector } from '../../../hooks/useStore'
import cx from 'classnames'
import FocusableButtonTS from '../../FocusableButton/FocusableButtonTS'
import { PreviewIcon } from '../../Icons'
import { ButtonProps } from '../types'
import { ContentActionButtonFocusKeys, ContentActionButtonLabel } from './types'

function Preview(props: ButtonProps) {
  const [isFocused, setIsFocused] = useState(false)
  const navigate = useNavigate()
  const content = useAppSelector((state) => state.content)
  const videoDetails = content.videoDetails

  const { hasRelated, relatedAssetUrl, relatedAssetVideoType } = videoDetails

  let onPressAction: () => void = () => {}
  if (hasRelated) {
    let relatedItemUrl = `${encodeURIComponent(relatedAssetUrl)}`
    if ('full_length' === relatedAssetVideoType) {
      relatedItemUrl = `/video-details/${relatedItemUrl}`
    } else {
      relatedItemUrl = `/video-playback/${relatedItemUrl}`
    }

    onPressAction = () => {
      navigate(relatedItemUrl)
      props.onPress(ContentActionButtonLabel.PREVIEW)
    }
  }

  const onFocus = () => {
    setIsFocused(true)
    props.onFocus({
      label: ContentActionButtonLabel.PREVIEW,
    })
  }

  const onBlur = () => {
    setIsFocused(false)
  }

  if (!hasRelated) {
    return <></>
  }
  return (
    <div className="video-detail-screen__control-button">
      <FocusableButtonTS
        focusKey={ContentActionButtonFocusKeys.PREVIEW}
        onEnterPress={onPressAction}
        onArrowPress={props.onArrowPress}
        onFocus={onFocus}
        onBlur={onBlur}
      >
        <PreviewIcon />
      </FocusableButtonTS>
      <span
        className={cx('video-detail-screen__control-button-label', {
          'video-detail-screen__control-button-label--focused': isFocused,
        })}
      >
        {ContentActionButtonLabel.PREVIEW}
      </span>
    </div>
  )
}

export default Preview
